module.exports = __webpack_public_path__ + "img/ic_edit.c43c3a22.svg";